import { getErrorResponse } from 'legacy/lut/functions'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'

import { ISPJBPDataResponse } from '../models/ISPJBPDataResponse'

export const fetchQbrPlanningData = async <T>(
  documentId: number,
  cancelObject?: HttpCancel
): Promise<ISPJBPDataResponse<T>> => {
  let response

  const url = proxy('/webservice/197/sp/v4/spJBPQBRPlanning/call')

  const payload = {
    'p.DocumentID': documentId,
  }

  const { app } = appGetState()
  const [accessToken] = getTokens(app.ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    response = await Rest.post({ url, payload, cancelObject, headers })
  } catch (e: any) {
    const errorMessage = `Failed to request QBR Planning Data. DocumentId: '${documentId}'.`
    response = getErrorResponse<ISPJBPDataResponse<T>>(e.message || errorMessage, {
      Total: -1,
      Data: [],
    })
  }

  return response
}
